import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import _ from 'lodash'

import { Button } from '@/components/componentLibrary'
import { TO_PARENT_PATH } from '@/modules/urlRouting/paths'

import { usePolicyEditContext } from '../../policyEditController'
import { getModalText } from '../../utils/modalText'
import { PolicyName } from '../PolicyDetails/Form/fields'

import './index.scss'

/**
 * Policy details header when editing, creating or duplicating a policy
 */
export const EditHeader = () => {
  const { t } = useTranslation()

  const controller = usePolicyEditContext()
  const { policy } = controller

  if (!policy) return null

  return (
    <div className="policy-details-header">
      <PolicyName
        editable
        editPolicy={controller.editPolicy}
        onValidate={controller.validatePolicy}
        policy={policy}
      />
      <div className="actions">
        <Link to={TO_PARENT_PATH} state={{ policyJson: controller.originalPolicy?.toJson }}>
          <Button secondary text={t('common.cancelTitle', 'Cancel')} />
        </Link>
        <Button
          onClick={async () => {
            const saved = await controller.save()
            if (saved && _.includes(policy.parkingFeeType, 'variable'))
              controller.setModalProps({ ...getModalText().INFO_DATA_PROCESSING })
          }}
          text={t('common.saveTitle', 'Save')}
        />
      </div>
    </div>
  )
}
